// direction
export function isRTL() {
  return document.body.dir === 'rtl';
}

export function isLTR() {
  return document.body.dir === 'ltr';
}

// media queries
const foundationBreakpoints = {
  small: '47.9375em',   // 767px
  medium: '48em',       // 768px
  large: '64em',        // 1024px
};

export function isLargeAndUp() {
  const mq = window?.matchMedia(`(min-width: ${foundationBreakpoints.large})`);
  return mq.matches;
}

export function isMediumAndUp() {
  const mq = window?.matchMedia(`(min-width: ${foundationBreakpoints.medium})`);
  return mq.matches;
}

export function isSmall() {
  const mq = window?.matchMedia(`(max-width: ${foundationBreakpoints.small})`);
  return mq.matches;
}
